import {
  SUBFLOW_STEPS,
  SUBSCRIPTION_EVENT_LABELS,
  CLICKED_ITEM_TYPES,
  SUBFLOW_STEPS_V3,
} from '@/core/constants';
import { pushToDataLayer } from './dataLayer';
import { formatPrice } from './currency';
import { track } from '@/utils/rudderstack';

export const getFullUrl = (path: string) => {
  const baseUrl = window?.location.origin;
  const urlPath = `${baseUrl}${path}`;
  return urlPath;
};

export function trackFlowStarted(path = '', version = 'v2') {
  const steps = version === 'v3' ? SUBFLOW_STEPS_V3 : SUBFLOW_STEPS;
  const startingStep =
    steps.find((step) => location.pathname.includes(step.path)) || steps[0];

  track(SUBSCRIPTION_EVENT_LABELS.SUBSCRIPTION_FLOW_STARTED, {
    firstStepName: startingStep.name,
    url: getFullUrl(path),
  });
}
export function trackStepStarted(payload = {}) {
  track(SUBSCRIPTION_EVENT_LABELS.SUBSCRIPTION_STEP_VIEWED, payload);
}
export function trackStepCompleted(payload = {}) {
  track(SUBSCRIPTION_EVENT_LABELS.SUBSCRIPTION_STEP_COMPLETED, payload);
}

export function trackFlowCompleted(payload = {}) {
  track(SUBSCRIPTION_EVENT_LABELS.SUBSCRIPTION_FLOW_COMPLETED, payload);
}

export function trackItemClicked(
  type: string,
  cta: string,
  additionalOpts = {},
) {
  const payload = { type, cta, ...additionalOpts };
  track(SUBSCRIPTION_EVENT_LABELS.ITEM_CLICKED, payload);
}
export function trackStepReturn(cta: string, path: string) {
  trackItemClicked(CLICKED_ITEM_TYPES.LINK, cta, { itemClickedPath: path });
}
export function trackErrorDisplayed(type: string, errors: string[]) {
  track(SUBSCRIPTION_EVENT_LABELS.ERROR_VIEWED, {
    type,
    errors,
  });
}

export function trackModal(
  type:
    | SUBSCRIPTION_EVENT_LABELS.RECOMMENDED_PLAY_KIT_MODAL_VIEWED
    | SUBSCRIPTION_EVENT_LABELS.RECOMMENDED_PLAY_KIT_MODAL_DISMISSED,
  payload: {
    childBirthDate: string | null;
    startingKitName: string;
    url: string;
  },
) {
  track(type, {
    payload,
  });
}

export function trackDollCustomOption(
  type: SUBSCRIPTION_EVENT_LABELS.SELECTED_CUSTOM_OPTION,
  payload: {
    selectedCustomOptions: string | null;
    startingKitName: string;
  },
) {
  track(type, {
    payload,
  });
}

export const getStep = (path: string) => {
  // short circuit path details when user is on the kit selection experiment page
  if (path === '/pages/subscription-v3/kit-selection') {
    return {
      path: 'kit-selection',
      name: 'Kit Selection',
      stepNum: 1,
    };
  }

  const urlArray = path.split('/');
  const slug = urlArray[urlArray.length - 1];
  const steps = SUBFLOW_STEPS_V3;

  return steps.find((step) => slug == step.path);
};

export const trackAddToCart = async (cartData: any) => {
  const ga4Object = {
    event: 'add_to_cart',
    ecommerce: {
      currency: cartData.currency,
      value: cartData.total_price,
      items: cartData.items.map((item: any, index: number) => {
        return {
          item_name: item.product_title,
          item_id: item.sku,
          affiliation: `Lovevery ${process.env.NEXT_PUBLIC_REGION}`,
          quantity: item.quantity,
          price: formatPrice(item.price),
          item_category: item.product_type,
          item_category2: item.item_category2,
          item_category3: item.item_category3,
          item_category4: item.item_category4,
          item_category5: item.item_category5,
          coupon: '',
          discount: item.discount,
          item_brand: 'Lovevery',
          item_variant: item.variant_title,
          item_list_name: item.list_name,
          item_list_id: item.list_id,
          index,
          productId: item.product_id,
          variantId: item.variant_id,
        };
      }),
    },
  };

  const UAObject = {
    event: 'addToCart',
    ecommerce: {
      currencyCode: cartData.currency,
      value: cartData.total_price,
      add: {
        products: cartData.items.map((item: any) => {
          return {
            name: item.product_title,
            id: item.sku,
            quantity: item.quantity,
            price: formatPrice(item.price),
            category: item.product_type,
            coupon: '',
            discount: item.discount,
            brand: 'Lovevery',
            variant: item.variant_title,
            list_name: item.list_name,
            list_id: item.list_id,
            productId: item.product_id,
            variantId: item.variant_id,
            imageUrl: item?.featured_image?.url || item?.image,
          };
        }),
      },
    },
  };

  pushToDataLayer(UAObject);

  // Clear previous ecommerce object before sending to GA4.
  // pushToDataLayer({ ecommerce: null });
  pushToDataLayer(ga4Object);
};
